import styled from 'styled-components';
import Events2 from './Events2';
import banner from '../../assets/img/Events/events-banner.png'
import UpcomingEvent from './UpcomingEvent';
import { Zoom,Fade } from 'react-reveal';
import Podcast from './Podcast';
function Events() {
  return (
    <Container> 

      <div className="event-img">
        <Fade>
        <img src={banner} alt="" />
          
        </Fade>


      </div>
          <EventContainer>
            {/* <Fade>
          <h1 className='h1'>As a community of <span>entrepreneurs</span> we thrive the journey to mastery, and develop maps that can guide others.</h1>
            </Fade> */}
            <div className="workshop-banner-text">
              
            <h1>Be a part of Our Entrepreneurial Reunion</h1>
            <p>It's  time to learn, brainstorm, dream and create</p>
            </div>

         <Events2/>

          </EventContainer>

        <UpcomingEvent/>
          <Podcast/>
    </Container>
  )
}

export default Events
const Container = styled.div` 
margin-bottom:1200px;

@media (max-width:990px){
  margin-bottom: 100rem;
}
@media (max-width:768px){
  margin-bottom: 170rem;
}
@media (max-width:570px){
  margin-bottom: 150rem;
}


box-sizing:border-box ;
margin-top:80px ;
height:500px ;
      .event-img img{
        width:100% ;
        height:500px ;
        object-fit:cover ;
      }
      text-align:center ;
      position:relative ;

`
const EventContainer = styled.div` 
position: absolute;
top:0;
width:100%;
height:100% ;
background-color:rgb(0,0,0,0.5) ;

        h1{
          width:90% ;
          margin:auto ;
          font-size:3.5vw;
          color:white ;
          padding-top:70px ;
          font-family:Montserrat bold;

        }
        span{
            font-size:5vw;
            color:#fa7525 ;
          }

        p{
          font-size:2em ;
        }
        .workshop-banner-text P{
          color:white ;
          font-size:3vw ;
          
        }
        .workshop-banner-text h1{
          font-size:4.5vw ;
          line-height:2em ;
        }
        
      
        @media (max-width:650px){
          h1{
            font-size:20px ;
            padding-top:50px ;
          }

        }
        @media(max-width:500px){
          form{
            background-color:rgb(0,0,0,0.1) ;
            border-radius:10px ;
          }

          input{
            border-radius:10px ;
          }
        }

`
